<template>
  <code><slot /></code>
</template>
